export const createTelegramLink = (path: string) => {
  return `https://t.me/${path}`
}
